import React, { Component } from 'react';
import { WithStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Grid, TextField, TableRow, TableCell, Checkbox, Button, withStyles } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import DeletePopUp from '../../../mylibrary/components/ContentCreate/wrapperComponent/popUps';
import { createCoursePlanStatesAction } from '../../reducers/createCoursePlanReducer';
import { connect } from 'react-redux';
import { onlyAllowNumbers } from '../../../../utils';
import MyPATCalendar from '../../../common/MyPATCalendar';
import moment from 'moment';
import {WEEK_FORMAT, getPhaseStatus} from './helpers/CoursePlanHelper';
import { getFormatedDate } from '../treeComponents/helper';
import _ from "lodash";

const styles = (theme: Theme) => createStyles({
    textField: {
      marginLeft: 5,
      marginRight: 5,
      width: 20,
    },
    menu: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit,
    },
    scrollHide:{
      overflow: 'auto',
      // maxWidth: 300,
      '&::-webkit-scrollbar': {
        display: 'none'
      },
    },
    // lastChild:{
    //   '&>:last-child':{
    //     paddingRight: 0,
    //     paddingLeft: 0,
    //   },
    //   '&>:nth-last-child(-n+2)':{
    //     paddingRight: 0,
    //     paddingLeft: 0,
    //   }
    // },
    // tdstyle:{
    //   minWidth: '236px',
    //   '&>div':{
    //     '&>div':{
    //       height: '44px',
    //     }
    //   }
    // },
    checkboxAlign:{
      '&>:first-child':{
        marginTop: '-7px'
      }
    },
    customTextField: {
      '&>div': {
        height: '44px',
        '&>div': {
          height: '44px',
        }
      }
    },
    dateSelect: {
      '&>div': {
        '&>div': {
          width: '175px',
          height: '44px',
        }
      },
      '& input':{
        cursor: 'pointer'
      },
      '& svg':{
        cursor: 'pointer'
      }
    },
    testLabel: {
      fontSize: 16,
      color: '#666'
    },
    manageCalendar:{
      
    },
    manageRowInput:{
      '& input':{
        padding: '10px 0',
        height: 22,
        textAlign: 'center',
      }
    }
  });

interface PhaseListProps extends WithStyles<typeof styles> {
  classes: any;
  subjectHeader: any;
  phaseData: any;
  deletePhase: Function;
  handlePhaseChange: Function;
  checkRevision: boolean;
  dispatch: any;
  coursePlanStates: any;
  phases: any;
  setPhaseData: Function;
  setCoursePlanStates: Function;
  handleChangeChecked: Function;
  startDate: any;
  endDate: any;
  checkWeek: any;
  checkTotalChapterCount:(subjectKey:any) => void;
  handlePhaseStatus: Function;
  //handlePhaseChange : (phaseDataId:any, subjectKey:any, event: any, isSubject:boolean) => void;
}
interface PhaseListState {
  checkRevision: boolean;
  isDelete: boolean;
  isRevision: boolean;
  isActive: boolean;
}

class PhaseList extends Component<PhaseListProps, PhaseListState> {
 checkTotalChapterCount: (subjectKey:any) => void;
 //handlePhaseChange: (phaseDataId:any, subjectKey:any, event: any, isSubject:boolean) => void;
  constructor(props: PhaseListProps) {
    super(props);
    this.state = {
      isDelete: false,
      isRevision: false,
      checkRevision: false,
      isActive: false,
    };
    
   this.checkTotalChapterCount = _.debounce(this.props.checkTotalChapterCount, 1000);
  // this.handlePhaseChange = _.debounce(this.props.handlePhaseChange,1000);
   
  }

  handleChange = () => {
    this.setState({ checkRevision: true });
  };

  handleDeleteClose = () => {
    this.setState({ isDelete: false });
  };
  handleDeleteSuccess = (phaseId: any) => {
    const { deletePhase } = this.props;
    // this.handleDeleteClose;
    this.setState({ isDelete: false }, () => {
      deletePhase(phaseId);
    });
  };

  handlePhaseDateByWeekFormat = (phaseDate: any) =>{
    const { checkWeek } = this.props;
    const result: any = (phaseDate != ''?(checkWeek? true: false): false);
    return result;
  }

  
  generateRow = () => {
    const { checkRevision } = this.state;
    let res: any = [];
    const { subjectHeader, classes, phaseData, handlePhaseChange,checkTotalChapterCount } = this.props;

    if (subjectHeader) {
      subjectHeader.forEach((subject: any,index:number) =>
        res.push(
         
          <TableCell key={index} className={classes.manageRowInput} style={{maxWidth: '100px', padding: '0 5px'}}>
            <TextField
            style={{textAlign: 'center',
              margin: '0',
              // maxWidth: '50px',
              minWidth: '50px',
              verticalAlign:'19px',
            }}
              variant='outlined'
              name='subject'
              id='filled-number'
              type='text'
              disabled={phaseData.isRevision}
              onChange={(e) => {
                handlePhaseChange(phaseData.id, Object.keys(subject), e, true);
                this.checkTotalChapterCount(Object.keys(subject));
              }}
              onBlur={(e) =>{this.checkTotalChapterCount(Object.keys(subject))}}
              value={subject[`${Object.keys(subject)}`]}
              onKeyPress={onlyAllowNumbers}
            />
            </TableCell>
          
        )
      );
    }

    return res;
  };

  render = () => {
    const { coursePlanStates = {}, phases } = this.props;
    const {weekFormat = ""} = coursePlanStates;
    const { isDelete, checkRevision, isActive } = this.state;
    const { classes, phaseData, deletePhase, handlePhaseChange, handleChangeChecked, handlePhaseStatus } = this.props;
    const { checkWeek } = this.props;
    //let startDate =moment(this.props.startDate,"YYYY-MM-DD").format("YYYY-MM-DD");
    //let endDate =  moment(this.props.endDate,"YYYY-MM-DD").format("YYYY-MM-DD");
    let startDate = getFormatedDate(this.props.startDate).join(" ");
    let endDate = getFormatedDate(this.props.endDate).join(" ");
     
     let startDateMin ="";
     let startDateMax = "";
     let endDateMin ="";
     let endDateMax = "";
     let isStartDateEnabled = true;
     let isEndDateEnabled = true;

    if (phaseData.id === 1) {
      startDateMin = startDate;
      startDateMax = endDate;
      endDateMin = moment(phases[`phase${phaseData.id}`].startDate, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
      endDateMax = endDate;

    } else {
      console.log(phases[`phase${phaseData.id - 1}`].endDate)
     
     if(phases[`phase${phaseData.id - 1}`].endDate !== ""){

        if(weekFormat === WEEK_FORMAT.MON_TO_SUN){
          
          let prePhaseEndDate = phases[`phase${phaseData.id - 1}`].endDate;
          const date = moment(prePhaseEndDate, 'YYYY-MM-DD');
          const prePhWeekDayNum = date.day();
        
          if (prePhWeekDayNum !== 0) {
           
            let nearestSunday = 7 - prePhWeekDayNum;
            let newEndDate = moment(prePhaseEndDate, 'YYYY-MM-DD')
              .add(nearestSunday+1, 'days')
              .format('YYYY-MM-DD');
              
              startDateMin = newEndDate;
          }else{
              startDateMin = moment(phases[`phase${phaseData.id - 1}`].endDate, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
          }
        }else if(weekFormat === WEEK_FORMAT.WEEKLY){

          let preStartDate = moment(phases[`phase${phaseData.id - 1}`].startDate, 'YYYY-MM-DD');
          let preEndDate = moment(phases[`phase${phaseData.id - 1}`].endDate, 'YYYY-MM-DD');

          let preEndDateDay = moment(preEndDate, 'YYYY-MM-DD').day();
          let weekEndDate :any= moment(preStartDate, "YYYY-MM-DD").add(6, 'days').format("YYYY-MM-DD");
          let weekEndDateDay = moment(weekEndDate, 'YYYY-MM-DD').day();
          if(preEndDateDay > weekEndDateDay){
            
            let lastWeekEndDate =  preEndDate.weekday(weekEndDateDay).format("YYYY-MM-DD");
            startDateMin = moment(lastWeekEndDate, "YYYY-MM-DD").add(7, 'days').format("YYYY-MM-DD");
          
         }else {

            startDateMin =  preEndDate.weekday(weekEndDateDay).format("YYYY-MM-DD");
          }

          startDateMin = moment(startDateMin, "YYYY-MM-DD").add(1, 'days').format("YYYY-MM-DD");
        
        }
       
        startDateMax = endDate;
  
        endDateMin = moment(phases[`phase${phaseData.id}`].startDate, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');;
        endDateMax = endDate;

      } else {
        isStartDateEnabled = false;
        isEndDateEnabled = false;
      }
    }
   

    return (
      <>
        <TableRow className={classes.lastChild}>
          <TableCell className={classes.tdstyle}>
            <TextField
              id="outlined-uncontrolled"
              fullWidth
              name="phase"
              //defaultValue={phaseData.phaseName}
              value={phaseData.phaseName}
              placeholder="Enter Phase Name"
              margin="normal"
              variant="outlined"
              onChange={(e) =>
                handlePhaseChange(phaseData.id, "phaseName", e, false)
              }
            />
          </TableCell>

          {this.generateRow()}
          {/* </TableCell> */}

          <TableCell className={classes.manageCalendar}>
           <MyPATCalendar
              fullWidthControl
              onChange={(date: any) =>
                handlePhaseChange(phaseData.id, "startDate", date, false)
              }
              date={phaseData.startDate}
              name="startDate"
              disabled={!isStartDateEnabled}
              minDate={startDateMin}
              maxDate={startDateMax}
              //errorText="Language Evaluation date cannot be less than evaluator's end date or more that request end date"
              initiallyTouched={false}
              //disabledDates={disableDateArr}
              //error={this.handlePhaseDateByWeekFormat(phaseData.startDate)}
              //errorText='Week Format changed'
            />
           
          </TableCell>
          <TableCell className={classes.manageCalendar}>
           
            <MyPATCalendar
              fullWidthControl
              onChange={(date: any) => {
                  handlePhaseChange(phaseData.id, "endDate", date, false);
                  const isActive = getPhaseStatus(phaseData.startDate, date);
                  this.setState({ isActive });
                }
              }
              date={phaseData.endDate}
              name="endDate"
              minDate={endDateMin}
              maxDate={endDateMax}
              //errorText="Language Evaluation date cannot be less than evaluator's end date or more that request end date"
              initiallyTouched={false}
              // label="Content Creation"
              disabled={!phaseData.startDate || !isEndDateEnabled}
             // error={this.handlePhaseDateByWeekFormat(phaseData.startDate)}
             // errorText='Week Format changed'
            />

          </TableCell>
          <TableCell align="right">
            <span className={classes.checkboxAlign}>
            <Checkbox
              color="primary"
              checked={phaseData.isRevision}
              onChange={(e) => {
                this.setState({ checkRevision: !checkRevision });
                handleChangeChecked(phaseData.id, e);
              }}
            />
            </span>
          </TableCell>
          <TableCell className="text-center">
            <span className="pr-20">
              <label className='switch switch-alternate'>
                <input
                  checked={this.state.isActive}
                  onChange={(event) => {
                    this.setState({ isActive: !isActive });
                    handlePhaseStatus(phaseData.id, event);
                  }}
                  type="checkbox"
                  disabled={!phaseData.startDate || !phaseData.endDate}
                />
                <span className="slider round"></span>
              </label>
            </span>
          </TableCell>
          <TableCell>
          <span className={classes.checkboxAlign}>
            {phaseData.id===1?'': <IconButton aria-label="Delete" style={{ color: "red" }}> 
              {/* <DeleteIcon
                onClick={() => {
                  this.setState({ isDelete: true });
                }}
              /> */}
              
              <img src="/assets/svg/delete-red.svg" onClick={() => {
                  this.setState({ isDelete: true });
                }}/>
              {isDelete ? (
                <DeletePopUp
                  openDialog={isDelete}
                  handleClose={() => {
                    this.handleDeleteClose();
                  }}
                  deleteText="Are you sure you want to delete this phase"
                  deleteTitle="Delete Phase"
                  deleteFunction={() => {
                    this.handleDeleteSuccess(phaseData.id);
                  }}
                />
              ) : (
                  ""
                )}
            </IconButton>
            }
            </span>
          </TableCell>
        </TableRow>
      </>
    );
  };
}

const mapStateToProps = (state: any) => ({
  coursePlanStates: state.createCoursePlanStates.coursePlanState,
  phases: state.createCoursePlanStates.phases,
  createCourse: state.createCoursePlanStates,
  checkWeek: state.createCoursePlanStates.checkWeek,
});

export default connect(
  mapStateToProps
  // @ts-ignore
)(withStyles(styles)(PhaseList));
